import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Breadcrumb, Button, ButtonGroup, Dropdown, DropdownButton, Form, Modal } from "react-bootstrap";
import { FaCheck, FaCogs, FaEdit, FaPaperPlane, FaPlus, FaTrash } from "react-icons/fa";
import LoadingComponent from "../../widgets/LoadingComponent";
import { FaXmark } from "react-icons/fa6";
import { getData, postData } from "../../api/ApiRest";
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import auditoriaSet from "../../widgets/Auditoria";
import { usePermission } from "../../helper/authHelper";

function PlantillasCorreos() {
    const [loading, setLoading] = useState(false);
    const [plantilla, setPlantilla] = useState([]);
    const [modalPlantillas, setModalPlantillas] = useState({ ModalVisible: false, Titulo: '', plantillaid: '' });
    const [infoPlantilla, setInfoPlantilla] = useState({
        codigo: '', descripcion: '', modulo: '', activo: false, plantilla: ''
    });
    const [infoPlantillaAnterior, setInfoPlantillaAnterior] = useState({
        codigo: '', descripcion: '', modulo: '', activo: false, plantilla: ''
    });
    const [configuracionEmail, setConfiguracionEmail] = useState({ ModalVisible: false, Titulo: '' });
    const [email, setEmail] = useState({
        origen: '', destino: '', plantillaid: ''
    });
    const [usersConfig, setUsersConfig] = useState([]);
    const [modalEnvio, setModalEnvio] = useState({
        ModalVisible: false, Titulo: ''
    });
    const [correosDestinos, setCorreosDestinos] = useState([]);

    const toolbarOptions = useMemo(
        () => [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
            [{ align: [] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }, { size: [] }],
            ["link", "image", "video"],
            ["clean"],
        ],
        []
    );

    ///Ref que se utiliza para el texto enriquecido
    const quillRef = useRef(null);

    const imageHandler = useCallback(() => {
        const url = prompt("Ingrese la URL pública de la imagen:");

        if (url) {
            const editor = quillRef.current.getEditor();
            const range = editor.getSelection(true);
            const index = range ? range.index : editor.getLength();

            editor.insertEmbed(index, "image", url, "user");
            editor.setSelection(index + 1, 0);
        }
    }, []);

    //Formatos permitidos en el texto enriquecido
    const formats = [
        "header",        // Encabezados
        "bold", "italic", "underline", "strike", "blockquote",
        "list", "bullet", "indent",
        "link", "image", "video", // Multimedia
        "color", "background",    // Colores
        "align", "font", "size"   // Alineación, fuentes y tamaños
    ];

    ///Modulos o propiedades que aparecen en el titulo enriquecido
    const modules = useMemo(
        () => ({
            toolbar: {
                container: toolbarOptions,
                handlers: {
                    image: imageHandler, // usa siempre la misma referencia
                },
            },
        }),
        [toolbarOptions, imageHandler]
    );

    const { GestionPlantilla, GestionConfigCorreo, GestionEnvio } = usePermission(["GestionPlantilla", "GestionConfigCorreo", "GestionEnvio"]);

    useEffect(() => {

        ///Validamos si hay valor en ambos campos para proceder a cargar en el render la información del modal
        if (modalPlantillas.ModalVisible && modalPlantillas.plantillaid) {
            getInfoModalPlantilla(modalPlantillas.plantillaid);
        } else {
            getPlantillas();
        }
    }, [modalPlantillas.ModalVisible, modalPlantillas.plantillaid]);

    const getPlantillas = () => {
        setLoading(true);

        getData('api/Configuracion/AdminEnvio/GetPlantillaCorreos').then(response => {

            if (response.status) {
                setPlantilla(response.plantillas);
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    ///Función para guardar una plantilla
    const guardarPlantilla = () => {
        if (!GestionPlantilla) {
            alert('No tienes permiso para esta acción');
            return;
        }

        setLoading(true);

        postData('api/Configuracion/AdminEnvio/guardarPlantillaCorreo', {
            plantillaid: modalPlantillas.plantillaid || ''
        }, infoPlantilla).then(response => {
            if (response.status) {
                alert('Plantilla configurada con éxito');

                ///Guardamos la auditoría del edit y del create
                if (modalPlantillas.plantillaid !== '') {
                    auditoriaSet(infoPlantillaAnterior, infoPlantilla, 'A', 'Plantilla', '', 'PlantillaEmail');
                } else {
                    auditoriaSet(infoPlantilla, {}, 'C', 'Plantilla', '', 'PlantillaEmail');
                }

                setModalPlantillas({ ModalVisible: false, Titulo: '', plantillaid: '' });
                getPlantillas();
            }

            setInfoPlantilla({ codigo: '', descripcion: '', modulo: '', activo: false, plantilla: '' });

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    //Función para eliminar una plantilla de correo
    const eliminarPlantilla = (plantillaid) => {
        if (!GestionPlantilla) {
            alert('No tienes permiso para esta acción');
            return;
        }

        setLoading(true);

        getData('api/Configuracion/AdminEnvio/eliminarPlantillaCorreo', {
            plantillaid: plantillaid
        }).then(response => {
            if (response.status) {
                alert('Plantilla eliminada con éxito');

                ///Registramos auditoría
                auditoriaSet(response.objecto, {}, 'E', 'Plantilla', '', 'PlantillaEmail');
                getPlantillas();
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Función para obtener la info de una plantilla en particular
    const getInfoModalPlantilla = (plantillaid) => {
        setLoading(true);

        getData('api/Configuracion/AdminEnvio/getInfoPlantillaCorreo', {
            plantillaid: plantillaid
        }).then(response => {
            if (response.status) {
                setInfoPlantilla(response.objectPlantilla);
                setInfoPlantillaAnterior(response.objectPlantilla);
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Función para poder agregar texto de mas cuando ya hay un parrafo establecido en el quill
    const insertaTexto = (texto) => {
        const editor = quillRef.current.getEditor();
        const range = editor.getSelection();

        if (range) {
            editor.insertText(range.index, texto);
        } else {
            editor.insertText(editor.getLength() - 1, texto);
        }
    }

    ///Función para guardar los correos que irían a cada plantilla en particular
    const guardarConfiguracionEmail = () => {
        if (!GestionConfigCorreo) {
            alert('No tienes permiso para esta acción');
            return;
        }

        setLoading(true);

        postData('api/Configuracion/AdminEnvio/guardarConfigUsuariosPlantilla', {
            origen: email.origen,
            destino: email.destino,
            plantillaid: email.plantillaid
        }).then(response => {
            if (response.status) {
                auditoriaSet(email, {}, 'C', 'Plantilla', '', 'PlantillaConfigEmail');
                verUsersConfig();
            }

            setEmail({ origen: '', destino: '', plantillaid: '' });
            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Función para visualizar los usuarios previamente configurados con su respectiva plantilla
    const verUsersConfig = () => {
        setLoading(true);

        getData('api/Configuracion/AdminEnvio/getUsersConfig').then(response => {
            setUsersConfig(response.correoConfig);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Función para eliminar un usuario configurado a una plantilla
    const eliminarUserConfig = (usuarioconfig) => {
        setLoading(true);

        getData('api/Configuracion/AdminEnvio/eliminarUserConfig', {
            usuarioconfig: usuarioconfig
        }).then(response => {
            if (response.status) {
                auditoriaSet(response.objecto, {}, 'E', 'Plantilla', '', 'PlantillaConfigEmail');
                verUsersConfig();
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Función para buscar correos a partir de una opción previa en el select de destino
    const buscaCorreosDestino = (destino) => {
        setLoading(true);

        getData('api/Configuracion/AdminEnvio/getCorreosDestinos', {
            destino: destino
        }).then(response => {
            setCorreosDestinos(response.correosDestinos);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Función que me permite enviar correos de forma masiva
    const enviarCorreos = async () => {
        if (!GestionEnvio) {
            alert('No tienes permiso para esta acción');
            return;
        }

        for (let i = 0; i < correosDestinos.length; i++) {
            const item = correosDestinos[i];

            ///Cambiamos el estado del cargando a verdadero
            setCorreosDestinos(prev =>
                prev.map((correo, index) =>
                    index === i ? { ...correo, loading: true } : correo
                )
            )

            try {
                await getData('api/Configuracion/AdminEnvio/enviarCorreosMasivos', {
                    origen: email.origen,
                    destino: item.destino,
                    plantillaid: email.plantillaid
                }).then(response => {

                    ///Actualizamos solo los campos que requerimos
                    setCorreosDestinos(prev =>
                        prev.map((correo, index) =>
                            index === i ?
                                {
                                    ...correo,
                                    status: response.resultadoEnvio[0].status,
                                    mensaje: response.resultadoEnvio[0].mensaje,
                                    loading: false
                                }
                                : correo
                        )
                    );

                    ///Construimos objecto para guardar al momento de enviar correos de forma masiva
                    let objectoEmail = {
                        origen: email.origen,
                        plantillaid: email.plantillaid,
                        correosDestinos
                    }

                    auditoriaSet(objectoEmail, {}, 'C', 'Plantilla', '', 'EnviaEmail');

                }, error => {
                    console.log(error);
                    setCorreosDestinos(prev =>
                        prev.map((correo, index) =>
                            index === i ?
                                {
                                    ...correo,
                                    status: false,
                                    mensaje: error,
                                    loading: false
                                }
                                : correo
                        )
                    );
                })
            } catch (error) {
                console.log(error);
            }
        }
    }

    return <div className='BodyComponent'>
        <Breadcrumb color='black'>
            <Breadcrumb.Item >Administración</Breadcrumb.Item>
            <Breadcrumb.Item active={true}>Plantillas</Breadcrumb.Item>
        </Breadcrumb>

        <div className="row">
            <div className="col-md-1">
                <Button variant='success'
                    className='mb-2' onClick={() => setModalPlantillas({ ModalVisible: true, Titulo: 'Nueva plantilla', plantillaid: '' })}>
                    <FaPlus size={'1rem'} />
                </Button>
            </div>
            <div className="col-md-1">
                <Button variant='dark'
                    className='mb-2' onClick={() => {
                        setEmail({ origen: '', destino: '', plantillaid: '' });
                        setConfiguracionEmail({ ModalVisible: true, Titulo: 'Nueva configuración' });
                        verUsersConfig();
                    }}>
                    <FaCogs size={'1rem'} />
                </Button>
            </div>
            <div className="col-md-1">
                <Button variant='primary'
                    className='mb-2' onClick={() => {
                        setEmail({ origen: '', destino: '', plantillaid: '' });
                        setModalEnvio({ ModalVisible: true, Titulo: 'Enviar correos masivos' });
                    }}>
                    <FaPaperPlane size={'1rem'} />
                </Button>
            </div>
        </div>



        {<LoadingComponent Loading={loading} />}
        <div className='table-responsive mt-2'>
            <table className='table table-sm table-bordered table-hover'>
                <thead>
                    <tr>
                        <th></th>
                        <th>
                            Código
                        </th>
                        <th>
                            Descripción
                        </th>
                        <th>
                            Acción
                        </th>
                        <th>
                            Activo
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {plantilla.map((item, index) => (
                        <tr key={item.correoplantillaid}>
                            <td className='text-center'>
                                <Button type='button' variant='primary' size='sm' title='Editar plantilla' className="me-2"
                                    onClick={() => {
                                        setModalPlantillas({ ModalVisible: true, Titulo: 'Editar plantilla', plantillaid: item.correoplantillaid });

                                        // getInfoModalPlantilla(item.correoplantillaid);
                                    }}>
                                    <FaEdit size={'1rem'} />
                                </Button>
                                <Button type='button' variant='danger' size='sm' title='Eliminar plantilla' onClick={() => eliminarPlantilla(item.correoplantillaid)}>
                                    <FaTrash size={'1rem'} />
                                </Button>
                            </td>
                            <td className="text-center">
                                {item.codigo}
                            </td>
                            <td className='text-center'>
                                {item.descripcion}
                            </td>
                            <td className='text-center'>
                                {item.modulo === 'N' ? 'Notificación' : item.modulo === 'AD' ? 'Alerta DIAN' : 'Alerta cliente'}
                            </td>
                            <td className='text-center'>
                                {item.activo ? <FaCheck size={'1rem'} /> : <FaXmark size={'1rem'} />}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>

        <Modal
            show={modalPlantillas.ModalVisible}
            onHide={() => {
                setInfoPlantilla({ codigo: '', descripcion: '', modulo: '', activo: false, plantilla: '' });
                setModalPlantillas({ ModalVisible: false, Titulo: '', plantillaid: '' })
            }}
            backdrop="static"
            keyboard={false}
            size="xl"
            animation={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{modalPlantillas.Titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <div className='row'>
                    <div className='col-md-3'>
                        <FloatingLabel controlId="codigoNewInput" label="Código">
                            <Form.Control
                                as="input"
                                type='text'
                                placeholder="Código"
                                rows={1}
                                autoComplete='off'
                                value={infoPlantilla.codigo}
                                onChange={event => setInfoPlantilla({ ...infoPlantilla, codigo: event.target.value })}
                            />
                        </FloatingLabel>
                    </div>
                    <div className='col-md-4'>
                        <FloatingLabel controlId="descripcionNewInput" label="Descripción">
                            <Form.Control
                                as="input"
                                type='text'
                                placeholder="Descripción"
                                rows={1}
                                autoComplete='off'
                                value={infoPlantilla.descripcion}
                                onChange={event => setInfoPlantilla({ ...infoPlantilla, descripcion: event.target.value })}
                            />
                        </FloatingLabel>
                    </div>
                    <div className='col-md-3'>
                        <FloatingLabel
                            controlId='AccionNewInput'
                            label="Acción"
                            className="mb-2"
                        >
                            <Form.Select
                                value={infoPlantilla.modulo}
                                onChange={event => {
                                    setInfoPlantilla({ ...infoPlantilla, modulo: event.target.value })
                                }}
                            >
                                <option value="">Seleccione</option>
                                <option value="N">Notificación</option>
                                <option value="AD">Alerta - Dian</option>
                                <option value="AC">Alerta - Cliente</option>
                            </Form.Select>
                        </FloatingLabel>
                    </div>
                    <div className='col-md-1'>
                        <label>Activo</label>
                        <Form.Check
                            style={{ textAlign: 'center', justifyContent: 'center' }}
                            required
                            checked={infoPlantilla.activo}
                            onChange={event => setInfoPlantilla({ ...infoPlantilla, activo: event.target.checked })}
                        />
                    </div>
                    <div className='col-md-1'>
                        <Button variant="success" size='sm' type='button' onClick={guardarPlantilla}>Guardar</Button>
                    </div>
                </div>
                <div className="row text-center" style={{ zIndex: 3000 }}>
                    <ButtonGroup>
                        <DropdownButton as={ButtonGroup} title="Cliente" id="bg-nested-dropdown" className="me-2">
                            <Dropdown.Item eventKey="[@CLIENTENOMBRE]" onClick={() => insertaTexto("[@CLIENTENOMBRE]")}>Nombre</Dropdown.Item>
                            <Dropdown.Item eventKey="[@CLIENTERAZONSOCIAL]" onClick={() => insertaTexto("[@CLIENTERAZONSOCIAL]")}>Razón social</Dropdown.Item>
                            <Dropdown.Item eventKey="[@CLIENTETIPOIDENTIFICACION]" onClick={() => insertaTexto("[@CLIENTETIPOIDENTIFICACION]")}>Tipo identificación</Dropdown.Item>
                            <Dropdown.Item eventKey="[@CLIENTEIDENTIFICACION]" onClick={() => insertaTexto("[@CLIENTEIDENTIFICACION]")}>Identificación</Dropdown.Item>
                            <Dropdown.Item eventKey="[@CLIENTEDV]" onClick={() => insertaTexto("[@CLIENTEDV]")}>Dv</Dropdown.Item>
                            <Dropdown.Item eventKey="[@CLIENTETELEFONO]" onClick={() => insertaTexto("[@CLIENTETELEFONO]")}>Telefono</Dropdown.Item>
                            <Dropdown.Item eventKey="[@CLIENTECORREO]" onClick={() => insertaTexto("[@CLIENTECORREO]")}>Correo</Dropdown.Item>
                            <Dropdown.Item eventKey="[@CLIENTEDIRECCION]" onClick={() => insertaTexto("[@CLIENTEDIRECCION]")}>Dirección</Dropdown.Item>
                            <Dropdown.Item eventKey="[@CLIENTEDPTO]" onClick={() => insertaTexto("[@CLIENTEDPTO]")}>Dpto/Ciudad</Dropdown.Item>
                        </DropdownButton>
                        <DropdownButton as={ButtonGroup} title="Certificado" id="bg-nested-dropdown" className="me-2">
                            <Dropdown.Item eventKey="[@CERTINOMBRE]" onClick={() => insertaTexto("[@CERTINOMBRE]")}>Nombre</Dropdown.Item>
                            <Dropdown.Item eventKey="[@CERTIFECHAEXPE]" onClick={() => insertaTexto("[@CERTIFECHAEXPE]")}>Fecha expedición</Dropdown.Item>
                            <Dropdown.Item eventKey="[@CERTIFECHAVENC]" onClick={() => insertaTexto("[@CERTIFECHAVENC]")}>Fecha vencimiento</Dropdown.Item>
                            <Dropdown.Item eventKey="[@CERTIDIASVIGEN]" onClick={() => insertaTexto("[@CERTIDIASVIGEN]")}>Dias vigencia</Dropdown.Item>
                            <Dropdown.Item eventKey="[@CERTIMESEXPEDIDO]" onClick={() => insertaTexto("[@CERTIMESEXPEDIDO]")}>Mes expedido</Dropdown.Item>
                            <Dropdown.Item eventKey="[@CERTIMESVENCI]" onClick={() => insertaTexto("[@CERTIMESVENCI]")}>Mes vencimiento</Dropdown.Item>
                        </DropdownButton>
                        <DropdownButton as={ButtonGroup} title="Plan" id="bg-nested-dropdown" className="me-2">
                            <Dropdown.Item eventKey="[@PLANCOD]" onClick={() => insertaTexto("[@PLANCOD]")}>Codigo</Dropdown.Item>
                            <Dropdown.Item eventKey="[@PLANID]" onClick={() => insertaTexto("[@PLANID]")}>Id</Dropdown.Item>
                            <Dropdown.Item eventKey="[@PLANNOMBRE]" onClick={() => insertaTexto("[@PLANNOMBRE]")}>Nombre</Dropdown.Item>
                            <Dropdown.Item eventKey="[@PLANTIPO]" onClick={() => insertaTexto("[@PLANTIPO]")}>Tipo</Dropdown.Item>
                            <Dropdown.Item eventKey="[@PLANFECHAINI]" onClick={() => insertaTexto("[@PLANFECHAINI]")}>Fecha inicio</Dropdown.Item>
                            <Dropdown.Item eventKey="[@PLANFECHAFIN]" onClick={() => insertaTexto("[@PLANFECHAFIN]")}>Fecha fin</Dropdown.Item>
                            <Dropdown.Item eventKey="[@PLANCANTFOLIOS]" onClick={() => insertaTexto("[@PLANCANTFOLIOS]")}>Cantidad folios</Dropdown.Item>
                            <Dropdown.Item eventKey="[@PLANFORMAPAGO]" onClick={() => insertaTexto("[@PLANFORMAPAGO]")}>Forma pago</Dropdown.Item>
                            <Dropdown.Item eventKey="[@PLANFACTURA]" onClick={() => insertaTexto("[@PLANFACTURA]")}>Factura</Dropdown.Item>
                            <Dropdown.Item eventKey="[@PLANCERTPLAM]" onClick={() => insertaTexto("[@PLANCERTPLAM]")}>Certificado plan</Dropdown.Item>
                            <Dropdown.Item eventKey="[@PLANPORCFOLIOS]" onClick={() => insertaTexto("[@PLANPORCFOLIOS]")}>% folios</Dropdown.Item>
                            <Dropdown.Item eventKey="[@PLANFOLIOSCONSU]" onClick={() => insertaTexto("[@PLANFOLIOSCONSU]")}>Folios consumidos</Dropdown.Item>
                            <Dropdown.Item eventKey="[@PLANFOLIOSDISPONI]" onClick={() => insertaTexto("[@PLANFOLIOSDISPONI]")}>Folios disponibles</Dropdown.Item>
                            <Dropdown.Item eventKey="[@PLANFOLIOSVENC]" onClick={() => insertaTexto("[@PLANFOLIOSVENC]")}>Dias restante venc</Dropdown.Item>
                            <Dropdown.Item eventKey="[@PLANFECHAFINCONS]" onClick={() => insertaTexto("[@PLANFECHAFINCONS]")}>Fecha fin consumo</Dropdown.Item>
                            <Dropdown.Item eventKey="[@PLANESTADO]" onClick={() => insertaTexto("[@PLANESTADO]")}>Estado</Dropdown.Item>
                            <Dropdown.Item eventKey="[@PLANPROYECCION]" onClick={() => insertaTexto("[@PLANPROYECCION]")}>Proyección</Dropdown.Item>
                        </DropdownButton>
                        <DropdownButton as={ButtonGroup} title="Varios" id="bg-nested-dropdown" className="me-2">
                            <Dropdown.Item eventKey="[@LINKBAJASUSCRIPCION]" onClick={() => insertaTexto("[@LINKBAJASUSCRIPCION]")}>Quitar suscripción</Dropdown.Item>
                        </DropdownButton>
                        <DropdownButton as={ButtonGroup} title="PQR" id="bg-nested-dropdown" className="me-2">
                            <Dropdown.Item eventKey="[@PQRCLIENTE]" onClick={() => insertaTexto("[@PQRCLIENTE]")}>Cliente</Dropdown.Item>
                            <Dropdown.Item eventKey="[@PQRFECHA]" onClick={() => insertaTexto("[@PQRFECHA]")}>Fecha</Dropdown.Item>
                            <Dropdown.Item eventKey="[@PQRNUMERO]" onClick={() => insertaTexto("[@PQRNUMERO]")}>Número</Dropdown.Item>
                        </DropdownButton>
                        <DropdownButton as={ButtonGroup} title="Documento" id="bg-nested-dropdown" className="me-2">
                            <Dropdown.Item eventKey="[@DOCUMENTO]" onClick={() => insertaTexto("[@DOCUMENTO]")}>Documento</Dropdown.Item>
                            <Dropdown.Item eventKey="[@FECHADOCUMENTO]" onClick={() => insertaTexto("[@FECHADOCUMENTO]")}>Fecha documento</Dropdown.Item>
                        </DropdownButton>
                    </ ButtonGroup>
                </div>
                <br />
                <div className="row">
                    <ReactQuill
                        ref={quillRef}
                        theme="snow"
                        value={infoPlantilla.plantilla}
                        onChange={(content) => setInfoPlantilla({ ...infoPlantilla, plantilla: content })}
                        modules={modules}
                        style={{
                            height: "500px",
                            maxHeight: "550px",
                            overflowY: "auto"
                        }}
                        formats={formats} />
                </div>
            </Modal.Body>

        </Modal>


        <Modal
            show={configuracionEmail.ModalVisible}
            onHide={() => {
                setEmail({ origen: '', destino: '', plantillaid: '' });
                setConfiguracionEmail({ ModalVisible: false, Titulo: '' })
            }}
            backdrop="static"
            keyboard={false}
            size="xl"
        >
            <Modal.Header closeButton>
                <Modal.Title>{configuracionEmail.Titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <div className='row'>
                    <div className='col-md-4'>
                        <FloatingLabel controlId="OrigenNewInput" label="Origen">
                            <Form.Control
                                as="input"
                                type='text'
                                placeholder="Correo origen"
                                rows={1}
                                autoComplete='off'
                                value={email.origen}
                                onChange={event => setEmail({ ...email, origen: event.target.value })}
                            />
                        </FloatingLabel>
                    </div>
                    <div className='col-md-4'>
                        <FloatingLabel controlId="destinoNewInput" label="Destino">
                            <Form.Control
                                as="input"
                                type='text'
                                placeholder="Correo Destino"
                                rows={1}
                                autoComplete='off'
                                value={email.destino}
                                onChange={event => setEmail({ ...email, destino: event.target.value })}
                            />
                        </FloatingLabel>
                    </div>
                    <div className='col-md-3'>
                        <FloatingLabel
                            controlId='floatingPlantilla'
                            label="Plantilla"
                            className="mb-3"
                        >
                            <Form.Select
                                size='sm'
                                value={email.plantillaid}
                                onChange={event => {
                                    setEmail({
                                        ...email,
                                        plantillaid: event.target.value
                                    })
                                }}
                            >
                                <option value="">Seleccione</option>
                                {plantilla.map((item, key) =>
                                    <option key={key} value={item.correoplantillaid}>{item.codigo} - {item.descripcion}</option>)}
                            </Form.Select>
                        </FloatingLabel>
                    </div>
                    <div className='col-md-1'>
                        <Button variant="success" size='sm' type='button' onClick={guardarConfiguracionEmail}>Guardar</Button>
                    </div>
                </div>
                <div className="row">
                    <table className='table table-sm table-bordered table-hover'>
                        <thead>
                            <tr>
                                <th></th>
                                <th>
                                    Origen
                                </th>
                                <th>
                                    Destino
                                </th>
                                <th>
                                    Plantilla
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {usersConfig.map((item, index) => (
                                <tr key={item.correoconfigid}>
                                    <td className='text-center'>
                                        <Button type='button' variant='danger' size='sm' title='Eliminar plantilla' onClick={() => eliminarUserConfig(item.correoconfigid)}>
                                            <FaTrash size={'1rem'} />
                                        </Button>
                                    </td>
                                    <td className="text-center">
                                        {item.origen}
                                    </td>
                                    <td className='text-center'>
                                        {item.destino}
                                    </td>
                                    <td className='text-center'>
                                        {item.plantilla}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Modal.Body>

        </Modal>

        <Modal
            show={modalEnvio.ModalVisible}
            onHide={() => {
                setEmail({ origen: '', destino: '', plantillaid: '' });
                setCorreosDestinos([]);
                setModalEnvio({ ModalVisible: false, Titulo: '' })
            }}
            backdrop="static"
            keyboard={false}
            size="xl"
        >
            <Modal.Header closeButton>
                <Modal.Title>{modalEnvio.Titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <div className='row'>
                    <div className='col-md-4'>
                        <FloatingLabel controlId="OrigenNewInput" label="Origen">
                            <Form.Control
                                as="input"
                                type='text'
                                placeholder="Correo origen"
                                rows={1}
                                autoComplete='off'
                                value={email.origen}
                                onChange={event => setEmail({ ...email, origen: event.target.value })}
                            />
                        </FloatingLabel>
                    </div>
                    <div className='col-md-3'>
                        <FloatingLabel
                            controlId='floatingDestinos'
                            label="Destino"
                            className="mb-3"
                        >
                            <Form.Select
                                size='sm'
                                value={email.destino}
                                onChange={event => {
                                    setEmail({
                                        ...email,
                                        destino: event.target.value
                                    });

                                    buscaCorreosDestino(event.target.value);
                                }}
                            >
                                <option value="">Seleccione</option>
                                <option value="P">Prueba</option>
                                <option value="C">Clientes</option>
                            </Form.Select>
                        </FloatingLabel>
                    </div>
                    <div className='col-md-3'>
                        <FloatingLabel
                            controlId='floatingPlantilla'
                            label="Plantilla"
                            className="mb-3"
                        >
                            <Form.Select
                                size='sm'
                                value={email.plantillaid}
                                onChange={event => {
                                    setEmail({
                                        ...email,
                                        plantillaid: event.target.value
                                    })
                                }}
                            >
                                <option value="">Seleccione</option>
                                {plantilla.map((item, key) =>
                                    <option key={key} value={item.correoplantillaid}>{item.codigo} - {item.descripcion}</option>)}
                            </Form.Select>
                        </FloatingLabel>
                    </div>
                    <div className='col-md-1'>
                        <Button variant="success" size='sm' type='button' onClick={enviarCorreos}>Enviar</Button>
                    </div>
                </div>
                <div className="row">
                    <table className='table table-sm table-bordered table-hover'>
                        <thead>
                            <tr>
                                <th>
                                    Origen
                                </th>
                                <th>
                                    Destino
                                </th>
                                <th>
                                    Estado
                                </th>
                                <th>
                                    Mensaje
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {correosDestinos.map((item, index) => (
                                <tr key={index}>
                                    <td className="text-center">
                                        {email.origen}
                                    </td>
                                    <td className='text-center'>
                                        {item.destino}
                                    </td>
                                    <td className='text-center'>
                                        {item.loading ? <img
                                            alt="loading"
                                            src="/tav-loading.gif"
                                            style={{ width: 20 }} /> :
                                            item.status ? <FaCheck size={'1rem'} /> : <FaXmark size={'1rem'} />}
                                    </td>
                                    <td className='text-center'>
                                        {item.mensaje}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Modal.Body>

        </Modal>
    </div>
}


export default PlantillasCorreos;